import ajax from '../../../utils/ajax'
import Pager from '../../../utils/pager'

export default class Advice {
    constructor(parent_id){
        this.parent_id = parent_id;
        this.parent = $(`${parent_id}`)[0];
        if(!this.parent){
            console.log(`no elements with id = ${parent_id}`)
            return ;
        }
        //
        this.page = new Pager((page_index)=>{
            this.pageIndex = page_index 
            this.list()
        }); 
        this.pageIndex = 1;
        this.pageSize = 10;
    }
    setToolbar(id){
        this.toolbarId = id;
    }
    setPageSize(page_size){
        this.pageSize = page_size
    }
    setPageIndex(page_index){   
        this.pageIndex = page_index;
    }
    getPageIndex(){
        return this.pageIndex
    }
    getPageSize(){
        return  this.pageSize
    }
    getTotal(total){
       return  this.total
    }
    setData(data){
        if(data){
            this.data = {...this.data,...data};
        }
    }
    async list(){
        if(!this.parent){
            console.error(`no elements with id = ${parent_id}`)
            return;
        }
        let data = this.data || {};
        let pageIndex = data.pageIndex || this.pageIndex || 1 ;
        if(pageIndex  < 1){
            pageIndex = 1;
        }
        let pageSize = data.pageSize || this.pageSize || 10 ;
        if(pageSize  < 1){
            pageSize = 10;
        }
        let res = await ajax({
            method: "GET",
            url : "/info/policy-lib/list.do",
            data: {
                "pageIndex" : pageIndex , "pageSize": pageSize ,  ...data
            }
        });
        if(res.success){
        }
        if(res.total > 0){
            let list =  res.list;
            if(list.length > 0){
                let row_html = new Array();
                row_html.push("<ul>")
                list.forEach(info => {
                    var date = info.z10;
                    if(!date){
                        date = ""
                    }
                    row_html.push(`
                        <li>
                        <a href="${info.filepath}" title="${info.topic}">${info.topic}</a><span class="date">${date}</span>
                        </li>`
                    )
                });
                //分页代码
                row_html.push("</ul>")
                //上级id
                $(`${this.parent_id}`).html(row_html.join(""));
                this.pageIndex = res.pageIndex ; 
                this.pageSize = res.pageSize ;
                this.total = res.total;

                this.page.setRowCount(this.total);
                this.page.setPageIndex(this.pageIndex);
                this.page.setPageSize(this.pageSize)

                let toolbar = this.page.createPagebar();
                
                $(`${this.toolbarId}`).html(toolbar)
                this.page.loadPageEvent(this.toolbarId)
            }else {
                $(`${this.parent_id}`).html("<div class='no-data'>暂无数据</div>")
            }
        }else{
            $(`${this.parent_id}`).html("<div class='no-data'>暂无数据</div>")
        }
      
    }
}

